import gql from 'graphql-tag';
import userRolesFragment from '../fragments/userRoles';

const GET_CUSTOMER_MEMBERS = gql`
  query GetCustomerMembers($customerId: ID!) {
    getCustomerMembers(customerId: $customerId) {
      users {
        id
        firstName
        lastName
        email
        # Deliberately not userRoleDetails: its nested customer field resolves
        # through customerService.getById, which authorizes at workspace/customer
        # scope and 403s for device-scoped members. The scalar customerId says
        # the same thing for free. device stays nested because the members
        # selectors need device.customerId; its resolver does not authorize, and
        # the User.userRoles resolver already trims these rows to the devices the
        # caller may see.
        userRoles {
          id
          customerId
          deviceId
          device {
            id
            customerId
          }
          role {
            id
            name
          }
        }
      }
      aggregate {
        rows
      }
    }
  }
`;

const GET_USERS_ROLES_BY_WORKSPACE = gql`
  query getUsersByWorkspaceId($workspaceId: ID!) {
    getUserRolesByWorkspace(workspaceId: $workspaceId) {
      userRoles {
        ...userRoleDetails
      }
    }
  }
  ${userRolesFragment.FRAGMENT_USER_ROLES}
`;

const GET_CHAT_USERS = gql`
  query GetChatUsersByWorkspaceId($workspaceId: ID!) {
    getChatUsersByWorkspaceId(workspaceId: $workspaceId) {
      users {
        id
        firstName
        lastName
        email
        currentWorkspace
        phone
        jobTitle
        language
        timezone
        profilePicture
        config
        createdAt
        updatedAt
      }
    }
  }
`;

const GET_CHAT_USERS_BY_SITUATION_ID = gql`
  query GetChatUsersBySituationId($situationId: ID!) {
    getChatUsersBySituationId(situationId: $situationId) {
      users {
        id
        firstName
        lastName
        email
        currentWorkspace
        phone
        jobTitle
        language
        timezone
        profilePicture
        config
        createdAt
        updatedAt
        isConnect
        lastUpdateConnect
      }
    }
  }
`;

export default {
  GET_CUSTOMER_MEMBERS,
  GET_USERS_ROLES_BY_WORKSPACE,
  GET_CHAT_USERS,
  GET_CHAT_USERS_BY_SITUATION_ID,
};
